(() => {
  const desktop = window.matchMedia('(min-width: 750px)');
  let changeToken = 0;
  let pointerPosition = null;

  const getPackInput = (target) => {
    const input = target.closest('input[name="Packungsgröße"]');
    if (input) return input;

    const label = target.closest('label[for]');
    const labelledInput = label ? document.getElementById(label.htmlFor) : null;
    return labelledInput?.matches('input[name="Packungsgröße"]') ? labelledInput : null;
  };

  document.addEventListener(
    'pointerdown',
    (event) => {
      if (!desktop.matches || !getPackInput(event.target)) return;
      pointerPosition = { left: window.scrollX, top: window.scrollY };
    },
    true
  );

  document.addEventListener(
    'change',
    (event) => {
      if (!desktop.matches || !getPackInput(event.target)) return;

      const token = ++changeToken;
      const position = pointerPosition || { left: window.scrollX, top: window.scrollY };
      pointerPosition = null;

      const restorePosition = () => {
        if (token !== changeToken) return;
        if (Math.abs(window.scrollY - position.top) > 1) {
          window.scrollTo({ ...position, behavior: 'auto' });
        }
      };

      window.requestAnimationFrame(() => {
        restorePosition();
        window.requestAnimationFrame(restorePosition);
      });

      [50, 150, 350].forEach((delay) => window.setTimeout(restorePosition, delay));
    },
    true
  );
})();
